export const CATEGORIES = [
  { value: "company-setup", label: "Company Setup" },
  { value: "vat", label: "VAT" },
  { value: "corporate-tax", label: "Corporate Tax" },
  { value: "accounting", label: "Accounting" },
  { value: "visas", label: "Visas" },
  { value: "banking", label: "Banking" },
  { value: "other", label: "Other" },
];

export function categoryLabel(value) {
  return CATEGORIES.find((c) => c.value === value)?.label || value;
}
